import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isEmpty } from 'lodash';
import { combineLatest } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { LanguagesStore, Settings } from '../core';
import { UserStorage } from '../user/user-storage';
import { DocumentAction, DocumentDownloader } from '../shared/document-downloader/document-downloader';
import { DlLink, LinkByFile } from './models/dlLink';
import { Report } from './models/report';
import { ReadDocumentMarker } from './unread-reports-storage';

@Injectable()
export class ReportDownloader {

    constructor(
        private settings: Settings,
        private http: HttpClient,
        private userStorage: UserStorage,
        private langStore: LanguagesStore,
        private documentDownloader: DocumentDownloader,
    ) { }

    public printReports(reports: Report[], readMarker: ReadDocumentMarker) {
        return this.getTheFiles('print', reports, readMarker);
    }

    public saveReports(reports: Report[], readMarker: ReadDocumentMarker) {
        return this.getTheFiles('save', reports, readMarker);
    }

    public getPreview(dlLink: DlLink) {
        const url = `${this.settings.apiUrl}/download/documentPreview`;
        return this.http.post(url, dlLink, { responseType: 'json' }).pipe(map(s => s.toString()));
    }

    private async getTheFiles(action: DocumentAction, reports: Report[], readMarker: ReadDocumentMarker) {
        if (isEmpty(reports)) {
            return;
        }

        const fileLinks = await this.getPrintOrSaveParams(reports);

        const success = await this.documentDownloader.downloadDocumentsByUrl(action, fileLinks);
        if (success) {
            return readMarker.markAsRead(reports);
        }
    }

    private getPrintOrSaveParams(reports: Report[]): Promise<DlLink[]> {

        return combineLatest(this.langStore.allLanguages, this.userStorage.currentUser)
            .pipe(
                map(([langs, user]) => {
                    const lang = user.settings.preferredLanguageId;
                    const defLangId = langs[0].languageRowId;
                    const fileLinks = reports.map(r => {
                        const fileLink = (r.fileLinks.find(f => f.languageId === lang) ||
                            r.fileLinks.find(f => f.languageId === defLangId) ||
                            r.fileLinks[0]);

                        return new LinkByFile(
                            fileLink ? fileLink.fileId : null,
                            r.reportId,
                            r.fileLinkCategory);
                    });
                    return fileLinks;
                }),
                first()
            )
            .toPromise();
    }
}
